import { CookiesCopiesType } from "@/shared/data/common.data";
import { ReactNode, createContext, useContext } from "react";

// Define the shape of your context data
interface I18nResourcesContextDataType {
  locale: "en" | "kr" | "us";
  resources: {
    cookiesCopies?: CookiesCopiesType;
  };
}

// Create the context
const I18nResourcesContext = createContext<
  I18nResourcesContextDataType | undefined
>(undefined);

// Create a provider component for your context
interface I18nResourcesProviderProps {
  children: ReactNode;
  locale: "en" | "kr" | "us";
  resources: {
    cookiesCopies?: CookiesCopiesType;
  };
}

export function I18nResourcesProvider({
  children,
  locale,
  resources,
}: I18nResourcesProviderProps) {
  return (
    <I18nResourcesContext.Provider value={{ locale, resources }}>
      {children}
    </I18nResourcesContext.Provider>
  );
}

// Create a custom hook for using the context
export function useI18nContext(): I18nResourcesContextDataType {
  const context = useContext(I18nResourcesContext);
  if (!context) {
    throw new Error(
      "useI18nContext must be used within a I18nResourcesProvider"
    );
  }
  return context;
}
